import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import sessionReducer from './session.store';
import allSessionsReducer from './all-sessions.store';
import siteData from './site-publish.store';
import fileStore from './file.store';
import draftSyncReducer from './draft-sync.store';
import cannyReducer from './canny.store';
import routeReducer from './route.store';
import liveSiteReducer from './live-site.store';
import businessProfileReducer from './business-profile.store';
import currentPlanReducer from './current-plan.store';
import partnerInfoReducer from './partner-info.store';
import referralReducer from './referral.store';
import siteAnalyticsReducer from './analytics.store';
import resourcesReducer from './resources.store';
import appReducer from './app.store';

export const rootReducer = combineReducers({
  session: sessionReducer,
  allSessions: allSessionsReducer,
  siteData: siteData,
  fileStore: fileStore,
  draftData: draftSyncReducer,
  canny: cannyReducer,
  route: routeReducer,
  liveSiteData: liveSiteReducer,
  businessProfile: businessProfileReducer,
  siteAnalytics: siteAnalyticsReducer,
  app: appReducer,
  currentPlan: currentPlanReducer,
  resources: resourcesReducer,
  partnerInfo: partnerInfoReducer,
  referral: referralReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.REACT_APP_ENV !== 'production',
});

export type AppDispatch = typeof store.dispatch;
